<rt-dialog-header [heading]="'tlc.members.give_admin_permissions_dialog.heading' | translate" />
<rt-dialog-body variant="white" layout-vertical>
  <span class="description">{{
    'tlc.members.give_admin_permissions_dialog.subheading' | translate
  }}</span>
  <tla-edit-member-permissions
    [admin]="adminData()!"
    [member]="memberData()!"
    (valueChanges)="handleValueChange($event)"
    (statusChanges)="handleStatusChange($event)"
    (selectedGroupChanges)="handleSelectedGroupChange($event)"
  />
</rt-dialog-body>
<rt-dialog-footer>
  <rt-button variant="plain" (click)="cancel()">
    {{ 'tlc.common.cancel' | translate }}
  </rt-button>
  <rt-button variant="primary" (click)="save()">
    {{ 'tlc.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>
